import ArrowRight from "@/public/custom-icons/icons-2/icons/Arrow Right 2/Line.svg";
import ArrowLeft from "@/public/custom-icons/icons-2/icons/Arrow Left 2/Line.svg";

const arrowsSvg = {
    ArrowRight,
    ArrowLeft,
};

export default arrowsSvg;
